import HOC from '../HOC';
import {bbc} from '../utility';

let Sports = () => {return null;}

export default HOC(Sports, bbc);



// WEBPACK FOOTER //
// ./src/components/News/Sports.js